import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  switchRole(event) {
    const formData = new FormData();
    formData.append('role', event.target.value);

    Rails.ajax({
      type: 'POST',
      url: '/break_the_glass',
      data: formData,
      success: (_response) => {
        window.location.reload();
      },
    });
  }
}
